import React, {ComponentType} from "react";
import BookingLinks from "./index";
import {IContainerProps, IHandlers, IProps, IServices} from './types';

/**
 * Gets the interface types as array of strings so we don't need hand code them each time (and reduces chance for mistakes).
 */
import {keys} from 'ts-transformer-keys';
import {hot} from "react-hot-loader";
import ReactUtilsService from "app/services/reactUtils.service";
import { IBookingLink } from "shared-types/index";


const NS = 'BookingLinksContainer';

const propsKeys: string[] = keys<IProps>();
const containerPropsKeys: string[] = keys<IContainerProps>();
const handlersKeys: string[] = keys<IHandlers>();
const servicesKeys: string[] = keys<IServices>();

const ThemeWrap = function (all: IProps & IContainerProps & IHandlers & IServices) {

  /**
   * Sorts 'all' into IServices, IProps and IContainerProps
   */
  const props: IProps = ReactUtilsService.getObjectByKeys(all, propsKeys) as IProps;
  const {bookingLinks, updateBookingLink, addBookingLink, editMode}: IContainerProps = ReactUtilsService.getObjectByKeys(all, containerPropsKeys) as IContainerProps;
  props.bookingLinks = bookingLinks || [];
  props.editMode = editMode;

  /**
   * Handlers used to modify app state (via a service) from within the module's container.
   * Similar to redux mapDispatchToProps.
   */
  const handlers: IHandlers = {
    updateBookingLink(bookingLinks: IBookingLink[]): IBookingLink[] {
      return updateBookingLink(bookingLinks);
    },
    addBookingLink(): void {
      return addBookingLink();
    }

  }

  return ReactUtilsService.containerWrap(
    <BookingLinks {...props} {...handlers} />
  );
}

/**
 * Returns properties needed for rendering react2angular
 */
export const R2ABookingLinks: [ComponentType<unknown>, never[]?, string[]?] = [
  hot(module)(ThemeWrap) as ComponentType<unknown>,
  [...containerPropsKeys] as never[],
  servicesKeys
];
